export default __webpack_public_path__ + "static/media/tequip_logo_with_text_for_darkbg.2fbc3865.png";